export default magazineCategoryFilter => {
    if ($('.magazine-teaser-wrapper[data-category]').length < 1) {
        return false;
    }

    $('.magazine-filter a').on('click', event => {
        let category = $(event.target).data('category');

        $('.magazine-filter a').removeClass('active');
        $(event.target).addClass('active');

        if (category == 'all') {
            $(`.magazine-teaser-wrapper[data-category]`).show();
        } else {
            $(`.magazine-teaser-wrapper[data-category!=${category}]`).hide();
            $(`.magazine-teaser-wrapper[data-category=${category}]`).show();
        }
    });
};